import { render } from "./ConcilioElrondView.vue?vue&type=template&id=02860a12"
import script from "./ConcilioElrondView.vue?vue&type=script&lang=js"
export * from "./ConcilioElrondView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__